import { Query } from '../../../../_base/actionBus/Query';
import { Booking } from '../../../../models/bookings/Booking';

export class GetBookings extends Query<Booking[]> {
    constructor(public amenityId: number, public myUnitFilter: boolean) {
        super();
    }
}
